// extracted by mini-css-extract-plugin
export var dropdown = "_tr-0";
export var imageWrapper = "_tr-3";
export var itemNameContainer = "_tr-1";
export var productImage = "_tr-2";
export var spinnerWrapper = "_tr-4";